import { CardContainer } from 'components/shared/CardContainer/CardContainer';
import { Location, PublicAccount } from '@trnsact/trnsact-shared-types';
import AddIcon from '@mui/icons-material/Add';
import { LocationsTable } from '../../tables';
import { Button } from '@mui/material';
import { ModalsKeys } from 'global';
import { useModal } from 'hooks/useModal';
import { UserProfile } from 'types';
import { ApolloQueryResult } from '@apollo/client';

interface Props {
  dealerAccount: PublicAccount;
  refetchDealerAccount: () => Promise<ApolloQueryResult<any>>;
}

export const LocationsCard = ({ dealerAccount, refetchDealerAccount }: Props) => {
  const { handleOpen: handleAddLocationDialogOpen } = useModal(ModalsKeys.AftermarketPartnerAddLocationDialog);

  const handleAddLocationClick = () => {
    handleAddLocationDialogOpen({
      accountDynamicsId: dealerAccount.dynamicsAccountId!,
      dealerContacts: dealerAccount.contacts as UserProfile[],
      refetchDealerAccount,
    });
  };

  return (
    <CardContainer
      title="Locations"
      actionBtn={
        <Button variant="contained" size="small" startIcon={<AddIcon />} onClick={handleAddLocationClick}>
          Add Location
        </Button>
      }
    >
      <LocationsTable tableData={dealerAccount?.locations as Location[]} />
    </CardContainer>
  );
};
